module.exports = __webpack_public_path__ + "img/logo-sm.390ad8d2.png";